import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { setupAppParams } from '@/store/modules/AppStore';
import Hero from "@/components/slices/Hero/Hero.vue"
import { gsap, ScrollTrigger } from 'gsap/all';
import useChapterState from './store/modules/useChapterState';
import Blocker from '@/components/blocks/Blocker.vue';
import FakeHeaderBar from '@/components/blocks/FakeHeaderBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  props: {
  'lang': {
    type: String,
    default: 'en',
    required: true
  }
},
  setup(__props) {

gsap.registerPlugin(ScrollTrigger);

const props = __props

const { state, app } = useChapterState();

const onFontLoaded = async () => {
  await nextTick()
  state.fontLoaded = true
  ScrollTrigger.refresh()
}

onMounted(() => {
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.finally(onFontLoaded)
  } else {
    onFontLoaded()
  }

  setupAppParams(props);
})

const { locale } = useI18n()
const currentLang = computed(() => locale.value)


return (_ctx: any,_cache: any) => {
  const _component_chapter_data = _resolveComponent("chapter-data")!
  const _component_scroll_up = _resolveComponent("scroll-up")!
  const _component_pixel_perfect_grid = _resolveComponent("pixel-perfect-grid")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ 'loading': _unref(state).isLoading }),
    ref_key: "app",
    ref: app
  }, [
    (_unref(state).fontLoaded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ready", [currentLang.value]])
        }, [
          _createVNode(Hero),
          _createVNode(_Transition, { css: false }, {
            default: _withCtx(() => [
              (!_unref(state).isLoading && _unref(state).chapterToLoad !== null)
                ? (_openBlock(), _createBlock(_component_chapter_data, {
                    key: _unref(state).chapterToLoad
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (!_unref(state).isLoading && _unref(state).chapterToLoad !== null)
            ? (_openBlock(), _createBlock(_component_scroll_up, { key: 0 }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(FakeHeaderBar),
    _createVNode(_component_pixel_perfect_grid),
    _createVNode(Blocker)
  ], 2))
}
}

})